"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRootView = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var pageMap_1 = require("@/rendering/common/pageMap");
exports.getRootView = function (page) {
    // tslint:disable-next-line:variable-name
    var ContentPage = pageMap_1.pageMap[page].view;
    return function (store) { return (React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(react_intl_1.IntlProvider, { locale: "en" },
            React.createElement(ContentPage, null)))); };
};
